import UnAuthComponent from '../layout/unauth.component';
import { FalkonchatIcon, UserNotFoundWarningIcon } from '../../icon';
import { useNavigate, useParams } from 'react-router';
import ButtonComponent from '../shared/button/button.component';
import { buttonLabels } from '../shared/constants';
import { AppRoutes } from '../routes/route.path';
import { useSelector } from 'react-redux';
import * as selector from '../../selectors/selectors';


const UserNotFound = () => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const navigate = useNavigate();
    const { deletedBy } = useParams()

    return (
        <div className={`d-flex flex-direction   m-auto color-login-secondary login-background br-4 ${IsMobileDevice ? "w-p-90 login-border h-p-80" : "w-p-40 h-p-60"}`}>
            <div className={`d-flex h-p-20`}>
                <FalkonchatIcon className="m-auto" />
            </div>
            <div className={`d-flex ${IsMobileDevice ? "h-p-30 pb-2" : "h-p-40"}`}>
                <UserNotFoundWarningIcon className="m-auto w-fill" />
            </div>
            <div className={` t-align-center my-auto ${IsMobileDevice ? " h-p-27 w-p-95" : "h-p-17"}`}>
                <div className={`mx-auto mobile-new-live-chat-header color-primary-accent t-align-center ${IsMobileDevice ? "py-1" : ""}`}>{`Link expired`}</div>
                <div className={`mx-auto live-chat-conversation-history color-email-sent-displaymsg ${IsMobileDevice ? "pb-1" : ""}`}>
                    Your username is not available or have been deleted.
                </div>
                <div className="mx-auto live-chat-conversation-history color-email-sent-displaymsg">
                    {`${deletedBy == "org" ? `Please contact your organization Admin.` : `Please contact your System Admin.`} `}
                </div>
            </div>
            <div className='h-p-15 d-flex justify-center'>
                <ButtonComponent ButtonLabel={buttonLabels.BACK_TO_LOGIN} Variant={'primary-btn'} ClassName='h4-regular' OnClick={() => navigate(AppRoutes.CHANNELS_SIGN_IN)} />
            </div>
            <div className="d-flex h-p-8">
                <a className={`underline m-auto color-login-text-field-font h4-regular f-link-hover ${IsMobileDevice ? "mb-2" : ""}`} href="https://share.hsforms.com/1uSaLr6GxTn-Mqid2VwLqzgcauh6">Contact support</a>
            </div>
        </div>
    )
}

export default (UnAuthComponent(UserNotFound));